/**
 * GoldMedalIcon - 金メダルアイコン（オリジナルSVG）
 *
 * 有料版スタンプカード購入者に付与される称号アイコン。
 *
 * デザイン構成:
 *   - 上部: 2色の布リボン（赤系グラデーション・光沢ライン付き）
 *   - メダル本体: 4層の同心円でゴールドの立体感を表現
 *   - 中央: 5角星（ダークゴールド）
 *   - 左上: 白い楕円ハイライトで金属光沢を演出
 *
 * Props:
 *   size      - 表示サイズ（px, デフォルト 20）
 *   className - 追加 Tailwind クラス
 *
 * アクセシビリティ:
 *   aria-hidden="true" を付与しているため、スクリーンリーダー向けの
 *   説明テキストは呼び出し元（StampUserList）側で sr-only として提供する。
 */
const GoldMedalIcon = ({ size = 20, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
  >
    {/* ── リボン ─────────────────────────────────── */}
    {/* 左帯（表面・明るい赤） */}
    <polygon points="9.5,1 12,1 11.5,9 9,9" fill="#DC2626" />
    {/* 右帯（影面・暗い赤） */}
    <polygon points="12,1 14.5,1 15,9 12.5,9" fill="#991B1B" />
    {/* 光沢ライン */}
    <line
      x1="10.3" y1="1.8"
      x2="9.8"  y2="8.2"
      stroke="#FCA5A5"
      strokeWidth="0.65"
      strokeLinecap="round"
    />

    {/* ── メダル本体 ──────────────────────────────── */}
    {/* 外縁（最も暗いゴールド：深みの影） */}
    <circle cx="12" cy="15" r="7.5" fill="#92400E" />
    {/* 外リング（ダークゴールド） */}
    <circle cx="12" cy="15" r="7"   fill="#D97706" />
    {/* 面（メインゴールド） */}
    <circle cx="12" cy="15" r="5.8" fill="#FBBF24" />
    {/* 内輝き（最も明るいゴールド） */}
    <circle cx="12" cy="15" r="4.8" fill="#FDE68A" />

    {/* ── 5角星 ────────────────────────────────── */}
    {/*
      中心 (12, 15)、外半径 3.8、内半径 1.5 で計算した座標
      各頂点は -90° から 72° 間隔、内点は -54° から 72° 間隔
    */}
    <path
      d="M12,11.2 L12.9,13.8 L15.6,13.8 L13.4,15.5 L14.2,18.1 L12,16.5 L9.8,18.1 L10.6,15.5 L8.4,13.8 L11.1,13.8 Z"
      fill="#D97706"
    />

    {/* ── ハイライト（金属光沢） ───────────────────── */}
    <ellipse
      cx="9.6" cy="12.2"
      rx="1.6" ry="0.9"
      fill="white"
      opacity="0.28"
      transform="rotate(-35 9.6 12.2)"
    />
  </svg>
);

export default GoldMedalIcon;
